import { useParams } from 'react-router-dom'
import { useLearningModule } from 'src/shared/hooks/learningModules'
import { Container } from 'src/shared/styled/Module'
import LoadingScreen from 'src/shared/views/LoadingScreen'
import LearningModuleDetail from '../views/LearningModuleDetail'

interface IParams {
  id: string
}

const LearningModuleContainer = () => {
  const { id } = useParams<IParams>()
  const { learningModule, isLoading } = useLearningModule(id)

  if (!learningModule || isLoading) {
    return <LoadingScreen />
  }

  return (
    <Container>
      <LearningModuleDetail learningModule={learningModule} />
    </Container>
  )
}

export default LearningModuleContainer
